export const UPDATE_OFFLINE_INVESTOR_ATTEMPT = 'UPDATE_OFFLINE_INVESTOR_ATTEMPT';
export type UPDATE_OFFLINE_INVESTOR_ATTEMPT = typeof UPDATE_OFFLINE_INVESTOR_ATTEMPT;

export const UPDATE_OFFLINE_INVESTOR_SUCCESS = 'UPDATE_OFFLINE_INVESTOR_SUCCESS';
export type UPDATE_OFFLINE_INVESTOR_SUCCESS = typeof UPDATE_OFFLINE_INVESTOR_SUCCESS;

export const UPDATE_OFFLINE_INVESTOR_FAILURE = 'UPDATE_OFFLINE_INVESTOR_FAILURE';
export type UPDATE_OFFLINE_INVESTOR_FAILURE = typeof UPDATE_OFFLINE_INVESTOR_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/project/offline-investor/update/Types.tsx